import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import toast from 'react-hot-toast';
import _ from 'lodash';
import { Box, Button } from '@mui/material';
import { Stack } from '@mui/system';
import Content from '../public/Content';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import CommentParent from '../../components/CommentParent';
import Cookies from 'universal-cookie';
import { fetchWith401Check } from '../../helpers/http';

const ModerationReview = ({ userInfo }) => {
  const cookies = new Cookies();
  const params = useParams();
  const [comment, setComment] = React.useState('');
  const [comments, setComments] = React.useState([]);
  const [repository, setRepository] = React.useState({});
  const [section, setSection] = React.useState('');
  const [loadingState, setLoadingState] = React.useState({ deleteComment: false, createComment: false, updateReview: false });
  const navigate = useNavigate();

  const API_URL = process.env.REACT_APP_STAGE === 'DEVELOPMENT' ? process.env.REACT_APP_API_HOST : process.env.REACT_APP_API_HOST_PROD;

  const fetchRepositoryByID = async () => {
    if (!params.id) return;
    if (!_.isEmpty(repository)) return;

    fetchWith401Check(`${API_URL}/tabledatas/summary/id?id=${params.id}`, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${cookies.get('token')}` },
      referrer: 'no-referrer',
    })
      .then(function (response) {
        if (response.ok) {
          return response.json();
        }
        return Promise.reject(response);
      })
      .then(function (response) {
        const repoData = response?.response || {};
        setRepository({ ...repository, ...repoData });
        fetchComments(repoData.id);
      })
      .catch(function (err) {
        return toast.error(err.message || 'Something wrong happenned');
      });
  };
  React.useEffect(() => {
    if (params?.id) fetchRepositoryByID();
  }, [params]);

  const fetchComments = async (id) => {
    const repId = repository.id || id;
    if (!repId) return;

    fetchWith401Check(`${API_URL}/reviews`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${cookies.get('token')}` },
      referrer: 'no-referrer',
      body: JSON.stringify({
        repository_id: repId,
        type: 'pdf_visual',
      }),
    })
      .then(function (response) {
        if (response.ok) {
          return response.json();
        }
        return Promise.reject(response);
      })
      .then(function (response) {
        setComments(response?.response);
      })
      .catch(function (err) {
        return toast.error(err.message || 'Something wrong happenned');
      });
  };

  const addComment = async () => {
    if (!comment) return toast.error('Please insert comment');
    if (!section) return toast.error('Please choose section');

    setLoadingState({ ...loadingState, addComment: true });

    try {
      fetchWith401Check(`${API_URL}/reviews/add`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${cookies.get('token')}` },
        referrer: 'no-referrer',
        body: JSON.stringify({
          content: { text: comment, section },
          status: 'created',
          created_by: userInfo.username,
          repository_id: repository.id,
          metadata: {},
          type: 'pdf_visual',
        }),
      })
        .then(function (response) {
          if (response.ok) {
            setLoadingState({ ...loadingState, addComment: false });
            return response.json();
          }
          return Promise.reject(response);
        })
        .then(function (response) {
          const data = response?.responses || {};
          toast.success('Comment saved successfully');
          fetchComments();
          setComment('');
          setSection('');
        })
        .catch(function (err) {
          setLoadingState({ ...loadingState, addComment: false });
          return toast.error(err.message || 'Something wrong happenned');
        });
    } catch (error) {
      setLoadingState({ ...loadingState, addComment: false });
    }
  };

  const doDeleteComment = async (item) => {
    const commentId = item.id;
    if (!commentId) return toast.error('Comment ID not found');

    setLoadingState({ ...loadingState, deleteComment: true });

    try {
      fetchWith401Check(`${API_URL}/reviews/delete_by_id`, {
        method: 'DELETE',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${cookies.get('token')}` },
        body: JSON.stringify({ id: commentId }),
      })
        .then(function (response) {
          if (response.ok) {
            setLoadingState({ ...loadingState, deleteComment: false });
            toast.success('Comment has been deleted');
            fetchComments(repository.id);
            return response.json();
          }
          return Promise.reject(response);
        })
        .catch(function (err) {
          setLoadingState({ ...loadingState, deleteComment: false });
          return toast.error(err.message || 'Something wrong happenned');
        });
    } catch (error) {
      toast.error(error.message || 'Something wrong happenned');
      setLoadingState({ ...loadingState, deleteComment: false });
    }
  };
  return (
    <Stack direction='row' sx={{ flex: 1, maxHeight: '100vh' }} spacing={4}>
      <Stack sx={{ flex: 2, overflow: 'scroll' }}>
        <Box m={2}>
          <Button onClick={() => window.history.back()} variant='outlined' startIcon={<ArrowBackIcon />}>
            Back
          </Button>
        </Box>
        <Content />
      </Stack>

      <CommentParent
        repository={repository}
        comments={comments}
        loadingState={loadingState}
        userInfo={userInfo}
        doDeleteComment={doDeleteComment}
        addComment={addComment}
        comment={comment}
        setComment={setComment}
        section={section}
        setSection={setSection}
      />
    </Stack>
  );
};

export default ModerationReview;
